import React from 'react';
import Typical from 'react-typical'
import "../css/bootstrap.css"
import "../css/app.css"

export const Home = () => {
    return (
    <div className="container black" >
      <div className="row d-flex justify-content-center" >
        <div className="col-lg-5 col-sm-7 d-flex flex-column justify-content-center align-items-center">
          <hr></hr>
          <div className="profile d-flex flex-column justify-content-center align-items-center">
            <p>Hi There, I'm</p>
            <h1 className="namehead">HEMANTH</h1>
            <Typical
              steps={['Web Developer 💻', 1500, 'Coding Enthusiast </>', 1500,  'Electrical Engineer ⚡', 1500, 'Ultimate Frisbee 🖤', 1500,]}
              loop={Infinity}
              wrapper="h3"
            />
            <br></br>
          </div>
          <hr></hr>
        </div>
      </div>
    </div>
    )
}